<template>
  <!-- EditDoneModal 編輯完成-->
  <!-- popUp - 設定完成視窗  -->
  <!-- Modal -->
  <div
    class="modal fade"
    id="editDoneModal"
    tabindex="-1"
    aria-labelledby="editDoneModalLabel"
    aria-hidden="true"
    ref="modal"
  >
    <div class="modal-dialog modal-dialog-centered">
      <div
        class="
          modal-content
          px-8
          py-5
          rounded-4
          position-relative
          shadow-sm
          p-3
          mb-5
          bg-body
          rounded
        "
      >
        <p class="fs-4 text-dark mb-4 text-center">個人檔案編輯成功！</p>
        <div class="row">
          <div class="col">
            <router-link
              :to="`/edit-profile/${emitUserData.Id}`"
              type="button"
              class="btn btn-dark rounded-pill text-white py-13 w-100"
              @click="hideModal()"
            >
              停留在編輯頁
            </router-link>
          </div>
          <div class="col">
            <router-link
              :to="`/profile/my-activity/${emitUserData.Id}`"
              type="button"
              class="btn btn-dark rounded-pill text-white py-13 w-100"
              @click="hideModal()"
            >
              回到個人檔案
            </router-link>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Modal from 'bootstrap/js/dist/modal'

export default {
  // 接收父層傳送來的 Data
  props: {
    parentEditDoneInfo: {
      type: Object,
      // 重點 : 避免傳進來是空的陣列或是物件
      default: () => {}
    }
  },
  data () {
    return {
      modal: {},
      emitUserData: {},
      // madal 背景靜態
      backdrop: true
    }
  },
  // 每次傳送的資料都不同，需監聽內容有無變動
  watch: {
    // 父層傳進來的值
    parentEditDoneInfo () {
      this.emitUserData = this.parentEditDoneInfo
    }
  },
  methods: {
    showModal () {
      this.modal.show()
    },
    hideModal () {
      this.modal.hide()
    }
  },
  mounted () {
    this.modal = new Modal(this.$refs.modal, this.backdrop)
    // this.$refs.modal.show()
  }
}
</script>
